let NetworkEnvironment = {
    RELEASE:0,
    TEST:1,
    DEVELOPMENT:2
}
export default NetworkEnvironment